import { FC, useCallback, useEffect } from "react";
import Modal from "../Modal/Modal";
import classes from "./BulkTransactionModal.module.scss";
import { sleep } from "../../solana/transactions/sendTransactions";
import { TransactionState } from "../../common/enums/common.enums";
import useTransactionStore from "../../context/transactionStore";
import TransactionItem from "./TransactionItem";

const BulkTransactionsModal: FC = () => {
  const {
    transactions,
    isProcessing,
    closeTransactionProcess,
    warningDescription,
    customTitle,
  } = useTransactionStore();

  const closeModalIfNeeded = useCallback(() => {
    if (
      !transactions.find(
        (item) => item.transactionState === TransactionState.Loading
      )
    ) {
      closeTransactionProcess();
    }
  }, [transactions, closeTransactionProcess]);

  useEffect(() => {
    void closeIfAllTransactionPassed();
  }, [transactions]);

  const closeIfAllTransactionPassed = async () => {
    if (
      transactions.filter(
        (item) => item.transactionState === TransactionState.Succeeded
      ).length === transactions.length
    ) {
      await sleep(2000);
      closeTransactionProcess();
    }
  };

  return (
    <>
      {isProcessing && (
        <Modal closeModal={closeModalIfNeeded}>
          <h1 className={classes.title}>{customTitle ?? "Transaction list"}</h1>

          {warningDescription && (
            <div className={classes.warning}>
              <p>{warningDescription}</p>
            </div>
          )}
          <div className={classes.transactions}>
            {transactions.map((item) => (
              <TransactionItem networkItem={item} key={item.number} />
            ))}
          </div>
        </Modal>
      )}
    </>
  );
};

export default BulkTransactionsModal;
